import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import AdvertPanelMenu from "./AdvertPanelMenu.vue";
import AdvertPanelContent from "./AdvertPanelContent.vue";
import { getAdvertisement } from "@/data";
import { AdvertisementList } from "@/data/index.type";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const advertisementChannelBody = ref<AdvertisementList>({});
const active = ref<string>();

getAdvertisement().then((res) => {
  advertisementChannelBody.value = res.data.data;
  const keys = Object.keys(advertisementChannelBody.value);
  if (keys.length > 0) {
    active.value = keys[0];
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style['advert-panel'])
  }, [
    _createElementVNode("div", null, [
      (active.value !== undefined)
        ? (_openBlock(), _createBlock(AdvertPanelMenu, {
            key: 0,
            data: advertisementChannelBody.value,
            active: active.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (active.value = $event))
          }, null, 8, ["data", "active"]))
        : _createCommentVNode("", true)
    ]),
    (active.value !== undefined)
      ? (_openBlock(), _createBlock(AdvertPanelContent, {
          key: 0,
          data: advertisementChannelBody.value,
          height: 1200,
          active: active.value!,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (active.value = $event))
        }, null, 8, ["data", "active"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})